const DEFAULT_ADMIN = {
  features: {
    globalFinances: false,
    globalClients: false,
    globalPushNotifs: false,
    globalCodePromo: false,
    globalProduct: false,
    changeShop: false,
    paymentType: false,
    canToggleFreelanceDrivers: true,
    modifyGlobalPromo: false,
    deliveryZone: false,
    specificHours: false,
    managementFee: false,
    refundOrder: false,
    productAndOption: false,
    infoBasketMessage: false,
    canToggleEmployeeDrivers: false,
    deliverySettings: false
  },
  pages: {
    designWeb: false,
    finance: false,
    marketing: false
  }
};

// Notes //

// if (Marketplace === true) {
//  shopAdmin: refunOrder = false;
//  all: globalproduct = false
// }

// Administrateur du shop //

export const FRANCHISE_SHOP_ADMIN = {
  ...DEFAULT_ADMIN,
  features: {
    ...DEFAULT_ADMIN.features,
    deliveryZone: true,
    refundOrder: true,
    specificHours: true,
    infoBasketMessage: true,
    canToggleEmployeeDrivers: true
  },
  pages: {
    ...DEFAULT_ADMIN.pages,
    finance: true
  }
};

export const CHAIN_SHOP_ADMIN = {
  ...DEFAULT_ADMIN,
  features: {
    ...DEFAULT_ADMIN.features,
    canToggleFreelanceDrivers: false
  }
};

export const INDEPENDANT_SHOP_ADMIN = {
  ...DEFAULT_ADMIN,
  features: {
    ...DEFAULT_ADMIN.features,
    deliveryZone: true,
    specificHours: true,
    managementFee: true,
    refundOrder: true,
    productAndOption: true,
    infoBasketMessage: true,
    canToggleEmployeeDrivers: true,
    deliverySettings: true
  },
  pages: {
    ...DEFAULT_ADMIN.features,
    finance: true,
    marketing: true
  }
};

// Administrateur de la bdd //

export const GENERAL_ADMIN = {
  features: {
    ...DEFAULT_ADMIN.features,
    globalFinances: true,
    globalClients: true,
    globalPushNotifs: true,
    globalCodePromo: true,
    globalProduct: true,
    changeShop: true,
    canToggleFreelanceDrivers: true,
    paymentType: true,
    modifyGlobalPromo: true,
    deliveryZone: true,
    specificHours: true,
    managementFee: true,
    refundOrder: true,
    productAndOption: true,
    infoBasketMessage: true,
    canToggleEmployeeDrivers: true,
    deliverySettings: true
  },
  pages: {
    designWeb: true,
    finance: true,
    marketing: true
  }
};

export const DISTRIBUTEUR_ADMIN = {
  features: {
    globalFinances: true,
    globalClients: true,
    globalPushNotifs: true,
    globalCodePromo: true,
    globalProduct: true,
    changeShop: true,
    paymentType: true,
    canToggleFreelanceDrivers: true,
    modifyGlobalPromo: true,
    deliveryZone: true,
    specificHours: true,
    managementFee: true,
    refundOrder: true,
    productAndOption: true,
    infoBasketMessage: true,
    canToggleEmployeeDrivers: true,
    deliverySettings: true
  },
  pages: {
    designWeb: true,
    finance: true,
    marketing: true
  }
};
